import { Mui, MuiIcons } from "@osu/react-ui";
import useRoleAuthentication from "../../Common/hooks/useRoleAuthentication";

const styles = {
  list: {
    textAlign: "right",
    width: "100%",
  },
  listItem: {
    padding: 0,
  },
  title: {
    width: "100%",
  },
};

const Demographics = (props) => {
  const { studentData } = props;
  const authDetails = useRoleAuthentication();
  
  return (
    <>
      <Mui.Grid container spacing={3}>
        <Mui.Grid size={{ xs: 12, md: 4 }}>
          <Mui.List sx={styles.list}>
          {authDetails.ADMIN && (
            <>
            <Mui.ListItem sx={styles.listItem}>
              <Mui.ListItemText
                sx={styles.title}
                primary={
                  <Mui.Typography variant="subtitle2" component='h3'>
                    Early Action
                  </Mui.Typography>
                }
              />
              <Mui.ListItemText
                primary={
                  studentData?.data?.demographics?.earlyAction === true ? "Yes" : "No"
                }
                sx={styles.list}
              />
            </Mui.ListItem>
            <Mui.Divider />
            </>
            )}
            <Mui.ListItem sx={styles.listItem}>
              <Mui.ListItemText
                sx={styles.title}
                primary={
                  <Mui.Typography variant="subtitle2" component='h3'>Campus</Mui.Typography>
                }
              />
              <Mui.ListItemText
                primary={studentData?.data?.demographics?.campus}
                sx={styles.list}
              />
            </Mui.ListItem>
            <Mui.Divider />
            <Mui.ListItem sx={styles.listItem}>
              <Mui.ListItemText
                sx={styles.title}
                primary={
                  <Mui.Typography variant="subtitle2" component='h3'>
                    Admit Term
                  </Mui.Typography>
                }
              />
              <Mui.ListItemText
                primary={studentData?.data?.demographics?.admitTerm?.value}
                sx={styles.list}
              />
            </Mui.ListItem>
            <Mui.Divider />
            <Mui.ListItem sx={styles.listItem}>
              <Mui.ListItemText
                sx={styles.title}
                primary={
                  <Mui.Typography variant="subtitle2" component='h3'>
                    Admit Type
                  </Mui.Typography>
                }
              />
              <Mui.ListItemText
                primary={studentData?.data?.demographics?.admitType}
                sx={styles.list}
              />
            </Mui.ListItem>
            <Mui.Divider />
            {authDetails.ADMIN && (<>
            <Mui.ListItem sx={styles.listItem}>
              <Mui.ListItemText
                primary={
                  <Mui.Typography variant="subtitle2" component='h3'>
                    Academic Program
                  </Mui.Typography>
                }
              />
              <div>
                <Mui.Tooltip
                  title={studentData?.data?.demographics?.academicProgram?.value}
                  placement="top"
                >
                  <Mui.Box
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <Mui.Typography
                      component="span"
                      style={{
                        padding: "5px",

                        cursor: "default",
                      }}
                    >
                      {studentData?.data?.demographics?.academicProgram?.key}
                    </Mui.Typography>
                    <MuiIcons.InfoOutlined
                      color="primary"
                      style={{ fontSize: "12px" }}
                    />
                  </Mui.Box>
                </Mui.Tooltip>
              </div>
            </Mui.ListItem>
            <Mui.Divider />
            <Mui.ListItem sx={styles.listItem}>
              <Mui.ListItemText
                primary={
                  <Mui.Typography variant="subtitle2" component='h3'>
                    Academic Plan
                  </Mui.Typography>
                }
              />
              <div>
                <Mui.Tooltip title={studentData?.data?.demographics?.academicPlan?.value} placement="top">
                  <Mui.Box
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <Mui.Typography
                      component="span"
                      style={{
                        padding: "5px",

                        cursor: "default",
                      }}
                    >
                      {studentData?.data?.demographics?.academicPlan?.key}
                    </Mui.Typography>
                    <MuiIcons.InfoOutlined
                      color="primary"
                      style={{ fontSize: "12px" }}
                    />
                  </Mui.Box>
                </Mui.Tooltip>
              </div>
            </Mui.ListItem>
            </>)}
          </Mui.List>
        </Mui.Grid>

        <Mui.Grid size={{ xs: 12, md: 4 }}>
          <Mui.List sx={styles.list}>
            {authDetails.ADMIN && (
            <>
            <Mui.ListItem sx={styles.listItem}>
              <Mui.ListItemText
                sx={styles.title}
                primary={
                  <Mui.Typography variant="subtitle2" component='h3'>
                    Regular Decision
                  </Mui.Typography>
                }
              />
              <Mui.ListItemText
                primary={
                  studentData?.data?.demographics?.onTime === true ? "Yes" : "No"
                }
                sx={styles.list}
              />
            </Mui.ListItem>
            <Mui.Divider />
            </>
            )}
            <Mui.ListItem sx={styles.listItem}>
              <Mui.ListItemText
                sx={styles.title}
                primary={
                  <Mui.Typography variant="subtitle2" component='h3'>
                    Low Socio-Economic
                  </Mui.Typography>
                }
              />
              <Mui.ListItemText
                primary={
                  studentData?.data?.demographics?.lowSocioeconomic === true
                    ? "Yes"
                    : "No"
                }
                sx={styles.list}
              />
            </Mui.ListItem>
            <Mui.Divider />

            <Mui.ListItem sx={styles.listItem}>
              <Mui.ListItemText
                sx={styles.title}
                primary={
                  <Mui.Typography variant="subtitle2" component='h3'>First Gen</Mui.Typography>
                }
              />
              <Mui.ListItemText
                primary={
                  studentData?.data?.demographics?.firstGeneration ? "Yes" : "No"
                }
                sx={styles.list}
              />
            </Mui.ListItem>
            <Mui.Divider />

            {authDetails.ADMIN && (<>
             <Mui.ListItem sx={styles.listItem}>
              <Mui.ListItemText
                sx={styles.title}
                primary={
                  <Mui.Typography variant="subtitle2" component='h3'>Eminence Applicant</Mui.Typography>
                }
              />
              <Mui.ListItemText
                primary={
                  studentData?.data?.demographics?.isEminence
                }
                sx={styles.list}
              />
            </Mui.ListItem>
            <Mui.Divider />
            </>)}
          </Mui.List>
        </Mui.Grid>

        <Mui.Grid size={{ xs: 12, md: 4 }}>
          <Mui.List sx={styles.list}>
            <Mui.ListItem sx={styles.listItem}>
              <Mui.ListItemText
                sx={styles.title}
                primary={
                  <Mui.Typography variant="subtitle2" component='h3'>
                    Country of Citizenship
                  </Mui.Typography>
                }
              />
              {studentData?.data?.countryOfCitizenship?.map((item, index) => (
                <Mui.ListItemText
                  key={index}
                  primary={item}
                  sx={styles.list}
                />
              ))}
            </Mui.ListItem>
            <Mui.Divider />

            <Mui.ListItem sx={styles.listItem}>
              <Mui.ListItemText
                sx={styles.title}
                primary={
                  <Mui.Typography variant="subtitle2" component='h3'>
                    Country of Home Address
                  </Mui.Typography>
                }
              />
              <Mui.ListItemText
                primary={
                  studentData?.data?.demographics?.homeCountry
                }
                sx={styles.list}
              />
            </Mui.ListItem>
            <Mui.Divider />

            <Mui.ListItem sx={styles.listItem}>
              <Mui.ListItemText
                sx={styles.title}
                primary={
                  <Mui.Typography variant="subtitle2" component='h3'>Ohio Resident</Mui.Typography>
                }
              />
              <Mui.ListItemText
                primary={
                  studentData?.data?.demographics?.ohioResident
                  }
                sx={styles.list}
              />
            </Mui.ListItem>
            <Mui.Divider />

            {authDetails.ADMIN ? (
              <>
                <Mui.ListItem sx={styles.listItem}>
                  <Mui.ListItemText
                    sx={styles.title}
                    primary={
                      <Mui.Typography variant="subtitle2" component='h3'>
                        Recruitment Category
                      </Mui.Typography>
                    }
                  />
                  <Mui.ListItemText
                    primary={studentData?.data?.demographics?.recruitmentCategory}
                    sx={styles.list}
                  />
                </Mui.ListItem>
                <Mui.Divider />

                <Mui.ListItem sx={styles.listItem}>
                  <Mui.ListItemText
                    sx={styles.title}
                    primary={
                      <Mui.Typography variant="subtitle2" component='h3'>
                        Load Date
                      </Mui.Typography>
                    }
                  />
                  <Mui.ListItemText
                    primary={studentData?.data?.demographics?.applicationDate}
                    sx={styles.list}
                  />
                </Mui.ListItem>
              </>
            ) : null}
          </Mui.List>
        </Mui.Grid>
      </Mui.Grid>
    </>
  );
};

export default Demographics;
